export default {
  install (Vue, options) {
    Vue.mixin({
      methods: {
        responseError (error) {
          if (error.status === 400) {
            this.$swal.fire({
              type: 'error',
              text: error.data['message_' + this.$i18n.locale]
            })
          }
        }
      }
    })
  }
}
